import type MarketPropertiesDialogProperties from './MarketPropertiesDialog.properties.ts';
import MarketPropertiesDialogDesktopView from './desktop/MarketPropertiesDialog.desktop.view.tsx';
import { useIsDesktopDevice } from '../../tools/hooks/useIsDesktopDevice.ts';

export default function MarketPropertiesDialogView(props: MarketPropertiesDialogProperties) {
  const isDesktop = useIsDesktopDevice();

  return <>{isDesktop && <MarketPropertiesDialogDesktopView {...props} />}</>;
}
